"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PulseOptionNames = void 0;
var PulseOptionNames;
(function (PulseOptionNames) {
    PulseOptionNames["embed"] = "embed";
    PulseOptionNames["token"] = "token";
    PulseOptionNames["disableExploreFilter"] = "disableExploreFilter";
    PulseOptionNames["layout"] = "embed_layout";
    PulseOptionNames["theme"] = "embed_theme";
    PulseOptionNames["ApiExternalVersion"] = ":apiExternalVersion";
    PulseOptionNames["ApiInternalVersion"] = ":apiInternalVersion";
    PulseOptionNames["EmbedCount"] = ":embcount";
    PulseOptionNames["PulseWebComponent"] = ":pulseWebComponent";
})(PulseOptionNames || (exports.PulseOptionNames = PulseOptionNames = {}));
//# sourceMappingURL=PulseInterface.js.map